import React, { useMemo } from "react";
import { FileCopy } from "@mui/icons-material";
import { FormLabel, Grid, Tooltip } from "@mui/material";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import Button from "../../../components/CustomButtons/Button";
import { convertArrayToSelectOptions } from "../../../templateHelpers";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { kitchenScreenButtonLayout } from "../../../variables/app";
import { useController, useFormContext } from "react-hook-form";
import { _get, _post } from "../../../http";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import { toast } from "react-toastify";
import FormFile from "../../../components/Forms/FormFile";
import ColorPickerV2 from "../../../components/CustomInput/ColorPickerV2";
import CustomSwitch from "../../../components/CustomInput/CustomSwitch";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import FormJson from "../../../components/Forms/FormJson";

const prefixUrl = "https://manage.jamezz.com/ks/";
const prefixUrlOs = "https://manage.jamezz.com/os/";

function Keukenscherm() {
  const { reloadDataFromServer, vestigingId, menukaartVestigingId } = useFormContext();
  const {
    field: { value: keukenschermValue },
  } = useController({ name: "keukenscherm" });

  const getPrefixUrl = (url) => {
    if (import.meta.env.MODE !== "production") {
      return url.replace("https://manage.jamezz.com", location.origin);
    }

    return url;
  };

  const getCode = useMemo(() => {
    return keukenschermValue?.ksCode ?? "";
  }, [keukenschermValue]);

  const getView = useMemo(() => {
    return getPrefixUrl(prefixUrl) + "view?kenmerk=" + getCode;
  }, [getCode]);

  const getTimeView = useMemo(() => {
    return getPrefixUrl(prefixUrl) + "timeview?kenmerk=" + getCode;
  }, [getCode]);

  const getViewOs = useMemo(() => {
    return getPrefixUrl(prefixUrlOs) + "view?kenmerk=" + getCode;
  }, [getCode]);

  const getTimeViewOld = useMemo(() => {
    return getPrefixUrl(prefixUrl) + "timeviewold?kenmerk=" + getCode;
  }, [getCode]);

  const resetScreenState = () => {
    _get(prefixUrl + "mark?orderId=null&kenmerk=" + getCode, null, {
      showSpinner: true,
      showToastSuccess: true,
      showToastError: true,
    }).then(() => {
      reloadDataFromServer();
    });
  };

  const selectAllActiveProducts = () => {
    const url = `/vestigingen/${menukaartVestigingId}/select-all-active-products`;
    _post(url, null, {
      showSpinner: true,
      showToastSuccess: true,
      showToastError: true,
    })
      .then((response) => {
        if (response?.data?.toggleProductList) {
          toast.success("All active products have been selected.");
        }
      })
      .catch((error) => {
        console.error("Error selecting all active products:", error);
        toast.error("Failed to select all active products.");
      });
  };

  const copyToClipBoard = (text) => {
    return new Promise((resolve, reject) => {
      console.log(navigator.permissions);

      if (navigator.clipboard && navigator.permissions) {
        const type = "text/plain";
        const blob = new Blob([text], { type });
        const data = [new ClipboardItem({ [type]: blob })];

        const permissionDescriptor = { name: "clipboard-write" };

        navigator.permissions.query(permissionDescriptor).then((permission) => {
          if (permission.state === "granted" || permission.state === "prompt") {
            navigator.clipboard
              .write(data)
              .then(() => {
                // Write toast message here
                toast.info(<TranslationWrapper tDefault={"Text gekopieerd"} tKey={"global.copy.text"} />);
                resolve();
              })
              .catch(reject);
          } else {
            reject(new Error("Permission not granted!"));
          }
        });
      } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();

        try {
          document.execCommand("copy");
          textarea.remove();
          // Write toast message here
          toast.info(<TranslationWrapper tDefault={"Text gekopieerd"} tKey={"global.copy.text"} />);
          resolve();
        } catch (e) {
          textarea.remove();
          reject(e);
        }
      } else {
        reject(new Error("None of the copying methods are supported by this browser!"));
      }
    });
  };

  const resetToken = () => {
    _get("core/vestigingen/" + vestigingId + "/resetkstoken", null, {
      showSpinner: true,
      showToastSuccess: true,
      showToastError: true,
    }).then(() => {
      reloadDataFromServer();
    });
  };

  //Dropdown opties
  const gereedKnop = [
    { value: "delivery", label: "Delivery" },
    { value: "pickup", label: "PickUp" },
  ];

  //Change buttoncolors kitchenscreen
  let {
    field: { value: keukenscherm__kitchenscreenColorsValue, onChange: keukenscherm__kitchenscreenColorsOnChange },
  } = useController({ name: "keukenscherm__kitchenscreenColors" });
  if (keukenscherm__kitchenscreenColorsValue) {
    keukenscherm__kitchenscreenColorsValue = JSON.parse(keukenscherm__kitchenscreenColorsValue);
  } else {
    keukenscherm__kitchenscreenColorsValue = {
      color1: "#2196F3",
      color2: "#FFC107",
      color3: "#FF5252",
      color4: "#4CAF50",
      color5: "#C625B9FF",
    };
  }

  let {
    field: { value: keukenscherm__settingsValue, onChange: keukenscherm__settingsOnChange },
  } = useController({ name: "keukenscherm__settings" });

  if (keukenscherm__settingsValue) {
    keukenscherm__settingsValue = JSON.parse(keukenscherm__settingsValue);
  } else {
    keukenscherm__settingsValue = {
      ordersButton: true,
      pickedUpButton: true,
      tableOrdersButton: true,
      productsButton: true,
      kitchenButton: true,
      itemsButton: true,
      dayReportButton: true,
      reprintButton: true,
      sectorsButton: true,
      advancedServout: false,
    };
  }

  const gereedKnopOptions = convertArrayToSelectOptions(gereedKnop, null);
  const kitchenScreenButtonLayoutOptions = convertArrayToSelectOptions(kitchenScreenButtonLayout, null);
  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Grid container>
        <Grid container item lg={12} xs={12}>
          <Card>
            <CardBody>
              <Grid item xs={12}>
                <h3>
                  <TranslationWrapper
                    tDefault={"Kitchen Display settings"}
                    tKey={"vestigingen.headers.keukenscherm.kitchendisplaysettings"}
                  />
                </h3>
              </Grid>
              <Grid item sm={8} xs={12}>
                <Button color={"primary"} onClick={resetToken} size={"sm"}>
                  <TranslationWrapper
                    tDefault={"Genereer connectie token"}
                    tKey={"vestigingen.form.keukenscherm.button.resetToken"}
                  />
                </Button>
              </Grid>
              {keukenschermValue?.connect_token ? (
                <>
                  <Grid item sm={4} xs={12}>
                    <FormLabel>
                      <TranslationWrapper
                        tDefault={"Connection token"}
                        tKey={"vestigingen.form.algemeen.label.connectionToken"}
                      />
                    </FormLabel>
                  </Grid>
                  <Grid item sm={8} xs={12}>
                    {keukenschermValue?.connect_token}
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <FormLabel>
                      <TranslationWrapper
                        tDefault={"Verloopt op"}
                        tKey={"vestigingen.form.algemeen.label.expires_at"}
                      />
                    </FormLabel>
                  </Grid>
                  <Grid item sm={8} xs={12}>
                    {keukenschermValue?.connect_token_expires_at}
                  </Grid>
                </>
              ) : null}
              <FormSwitchTC
                name={"keukenSchermen"}
                tDefault={"Keukenschermen"}
                tKey={"vestigingen.form.algemeen.label.keukenSchermen"}
              />
              <FormSwitchTC
                name={"useKSAuth"}
                tDefault={"Kitchen screen user auth"}
                tKey={"vestigingen.form.algemeen.label.useKSAuth"}
              />{" "}
              <FormSwitchTC
                name={"ks_multi_status"}
                tDefault={"Multi status setup"}
                tKey={"vestigingen.form.algemeen.label.ks_multi_status"}
              />
              <FormSwitchTC
                name={"ks_autoremove_picked_up_orders_from_os"}
                tDefault={"Remove picked up orders from ready column on the order screen"}
                tKey={"vestigingen.form.algemeen.label.ks_autoremove_picked_up_orders_from_os"}
              />
              <FormSwitchTC
                name={"ks_use_pager"}
                tDefault={"Use pager number instead of table number"}
                tKey={"vestigingen.form.algemeen.label.ks_use_pager"}
              />
              <FormSelectTC
                name={"keukenSchermMessageMode"}
                options={gereedKnopOptions}
                tDefault={"Gereedknop"}
                tKey={"vestigingen.form.algemeen.label.keukenSchermMessageMode"}
              />
              <FormSwitchTC
                name={"keukenSchermSMS"}
                tDefault={"Keukenschermen SMS"}
                tKey={"vestigingen.form.algemeen.label.keukenSchermSMS"}
              />
              <FormSelectTC
                name={"kitchenScreenButtonLayout"}
                options={kitchenScreenButtonLayoutOptions}
                tDefault={"Keukenscherm ophaal buttons"}
                tKey={"vestigingen.form.algemeen.label.kitchenScreenButtonLayout"}
              />
              <Grid item sm={4} style={{ paddingTop: "10px" }} xs={12}>
                <FormLabel>
                  <TranslationWrapper
                    tDefault={"Set open orders to pickedup"}
                    tKey={"vestigingen.form.algemeen.label.markOrderAsPickedup"}
                  />
                </FormLabel>
              </Grid>
              <Grid item sm={8} xs={12}>
                <Button color={"primary"} onClick={resetScreenState} size={"sm"}>
                  <TranslationWrapper tKey={"Reset order screen"} />
                </Button>
              </Grid>
              <FormControlledInputTC
                name={"osWaitTime"}
                rules={{
                  min: { value: 0, message: getTranslation("The minimum value is 0!") },
                }}
                tDefault={"Order screen timeout"}
                tKey={"vestigingen.form.algemeen.label.orderScreenTimeout"}
              />
              <FormControlledInputTC
                name={"queryDays"}
                rules={{
                  min: { value: 1, message: getTranslation("The minimum value is 1!") },
                }}
                tDefault={"KDS Query days"}
                tKey={"vestigingen.form.algemeen.label.queryDays"}
              />
              <Grid item sm={8} xs={12}>
                <Button color={"primary"} onClick={selectAllActiveProducts} size={"sm"}>
                  <TranslationWrapper tKey={"Select all active products"} />
                </Button>
              </Grid>
              <FormAsyncTC
                async={{
                  url:
                    "core/producten/search?fields=id as value, naam as label&per_page=1000&sort_field=naam&vestiging_id=" +
                    menukaartVestigingId,
                  searchField: "naam",
                }}
                key={"extra_settings__toggleProductList" + menukaartVestigingId}
                multiple={true}
                name={"extra_settings__toggleProductList"}
                tDefault={"Toggle product list"}
                tKey={"extra_settings__toggleProductList"}
              />
            </CardBody>
          </Card>
        </Grid>
        <Grid container lg={12} spacing={1} xs={12}>
          <Card>
            <CardBody>
              <Grid item xs={12}>
                <h3>
                  <TranslationWrapper
                    tDefault={"Layout settings"}
                    tKey={"vestigingen.form.algemeen.label.ksLayoutSettings"}
                  />
                </h3>
              </Grid>
              <Card>
                <CardBody>
                  <Grid container spacing={2}>
                    <Grid item sm={4} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Food ready (sms)"}
                          tKey={"vestigingen.form.algemeen.label.kitchenscreenColors"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <ColorPickerV2
                        nullable={true}
                        onChange={(color) => {
                          keukenscherm__kitchenscreenColorsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__kitchenscreenColorsValue,
                                color1: color,
                              }),
                            },
                          });
                        }}
                        value={keukenscherm__kitchenscreenColorsValue.color1}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Drinks ready (sms)"}
                          tKey={"vestigingen.form.algemeen.label.kitchenscreenColors"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <ColorPickerV2
                        nullable={true}
                        onChange={(color) => {
                          keukenscherm__kitchenscreenColorsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__kitchenscreenColorsValue,
                                color2: color,
                              }),
                            },
                          });
                        }}
                        value={keukenscherm__kitchenscreenColorsValue.color2}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Ready (nosms)"}
                          tKey={"vestigingen.form.algemeen.label.kitchenscreenColors"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <ColorPickerV2
                        nullable={true}
                        onChange={(color) => {
                          keukenscherm__kitchenscreenColorsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__kitchenscreenColorsValue,
                                color3: color,
                              }),
                            },
                          });
                        }}
                        value={keukenscherm__kitchenscreenColorsValue.color3}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Order Ready!!"}
                          tKey={"vestigingen.form.algemeen.label.kitchenscreenColors"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <ColorPickerV2
                        nullable={true}
                        onChange={(color) => {
                          keukenscherm__kitchenscreenColorsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__kitchenscreenColorsValue,
                                color4: color,
                              }),
                            },
                          });
                        }}
                        value={keukenscherm__kitchenscreenColorsValue.color4}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Reprint"}
                          tKey={"vestigingen.form.algemeen.label.kitchenscreenColors"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <ColorPickerV2
                        nullable={true}
                        onChange={(color) => {
                          keukenscherm__kitchenscreenColorsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__kitchenscreenColorsValue,
                                color5: color,
                              }),
                            },
                          });
                        }}
                        value={keukenscherm__kitchenscreenColorsValue.color5}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Item background color"}
                          tKey={"vestigingen.form.algemeen.label.itemBgColor"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <ColorPickerV2
                        nullable={true}
                        onChange={(color) => {
                          keukenscherm__kitchenscreenColorsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__kitchenscreenColorsValue,
                                bgColor: color,
                              }),
                            },
                          });
                        }}
                        value={keukenscherm__kitchenscreenColorsValue.bgColor}
                      />
                    </Grid>
                  </Grid>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Show orders button"}
                          tKey={"vestigingen.form.algemeen.label.ksordersButton"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <CustomSwitch
                        checked={keukenscherm__settingsValue.ordersButton ?? true}
                        onChange={() => {
                          keukenscherm__settingsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__settingsValue,
                                ordersButton: event.srcElement.checked,
                              }),
                            },
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Show picked up button"}
                          tKey={"vestigingen.form.algemeen.label.kspickedUpButton"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <CustomSwitch
                        checked={keukenscherm__settingsValue.pickedUpButton ?? true}
                        onChange={() => {
                          keukenscherm__settingsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__settingsValue,
                                pickedUpButton: event.srcElement.checked,
                              }),
                            },
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Show table orders button"}
                          tKey={"vestigingen.form.algemeen.label.kstableOrdersButton"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <CustomSwitch
                        checked={keukenscherm__settingsValue.tableOrdersButton ?? true}
                        onChange={() => {
                          keukenscherm__settingsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__settingsValue,
                                tableOrdersButton: event.srcElement.checked,
                              }),
                            },
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Show products button"}
                          tKey={"vestigingen.form.algemeen.label.ksproductsButton"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <CustomSwitch
                        checked={keukenscherm__settingsValue.productsButton ?? true}
                        onChange={() => {
                          keukenscherm__settingsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__settingsValue,
                                productsButton: event.srcElement.checked,
                              }),
                            },
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Show kitchen button"}
                          tKey={"vestigingen.form.algemeen.label.kskitchenButton"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <CustomSwitch
                        checked={keukenscherm__settingsValue.kitchenButton ?? true}
                        onChange={() => {
                          keukenscherm__settingsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__settingsValue,
                                kitchenButton: event.srcElement.checked,
                              }),
                            },
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Show items button"}
                          tKey={"vestigingen.form.algemeen.label.ksitemsButton"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <CustomSwitch
                        checked={keukenscherm__settingsValue.itemsButton ?? true}
                        onChange={() => {
                          keukenscherm__settingsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__settingsValue,
                                itemsButton: event.srcElement.checked,
                              }),
                            },
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Show day report button"}
                          tKey={"vestigingen.form.algemeen.label.ksdayReportButton"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <CustomSwitch
                        checked={keukenscherm__settingsValue.dayReportButton ?? true}
                        onChange={() => {
                          keukenscherm__settingsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__settingsValue,
                                dayReportButton: event.srcElement.checked,
                              }),
                            },
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Show sectors button"}
                          tKey={"vestigingen.form.algemeen.label.kssectorsButton"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <CustomSwitch
                        checked={keukenscherm__settingsValue.sectorsButton ?? true}
                        onChange={() => {
                          keukenscherm__settingsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__settingsValue,
                                sectorsButton: event.srcElement.checked,
                              }),
                            },
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Show order confirmation button"}
                          tKey={"vestigingen.form.algemeen.label.orderConfirmation"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <CustomSwitch
                        checked={keukenscherm__settingsValue.confirmButton ?? false}
                        onChange={() => {
                          keukenscherm__settingsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__settingsValue,
                                confirmButton: event.srcElement.checked,
                              }),
                            },
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Show reprint button on order"}
                          tKey={"vestigingen.form.algemeen.label.reprintButton"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <CustomSwitch
                        checked={keukenscherm__settingsValue.reprintButton ?? true}
                        onChange={() => {
                          keukenscherm__settingsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__settingsValue,
                                reprintButton: event.srcElement.checked,
                              }),
                            },
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Partial serveout mode"}
                          tKey={"vestigingen.form.algemeen.label.partialServeout"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <CustomSwitch
                        checked={keukenscherm__settingsValue.advancedServout ?? false}
                        onChange={() => {
                          keukenscherm__settingsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__settingsValue,
                                advancedServout: event.srcElement.checked,
                              }),
                            },
                          });
                        }}
                      />
                    </Grid>
                  </Grid>{" "}
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Order ready on all screens"}
                          tKey={"vestigingen.form.algemeen.label.orderReadyOnAllScreen"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <CustomSwitch
                        checked={keukenscherm__settingsValue.orderReadyOnAllScreens ?? false}
                        onChange={() => {
                          keukenscherm__settingsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__settingsValue,
                                orderReadyOnAllScreens: event.srcElement.checked,
                              }),
                            },
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Show toggle salesarea button"}
                          tKey={"vestigingen.form.algemeen.label.salseAreaButton"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <CustomSwitch
                        checked={keukenscherm__settingsValue.salesAreaButton ?? true}
                        onChange={() => {
                          keukenscherm__settingsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__settingsValue,
                                salesAreaButton: event.srcElement.checked,
                              }),
                            },
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={4}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Enable salesarea button pincode"}
                          tKey={"vestigingen.form.algemeen.label.salseAreaButton.lock"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <CustomSwitch
                        checked={keukenscherm__settingsValue.salesAreaButtonLock ?? false}
                        onChange={() => {
                          keukenscherm__settingsOnChange({
                            target: {
                              value: JSON.stringify({
                                ...keukenscherm__settingsValue,
                                salesAreaButtonLock: event.srcElement.checked,
                              }),
                            },
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} style={{ paddingTop: "10px" }}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={4}>
                      <FormLabel>
                        <TranslationWrapper tDefault={"Employee pin codes"} tKey={"custom_data.employee_codes"} />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={8}>
                      <FormJson name={"custom_data.employee_codes"} rules={{ required: true }} />
                    </Grid>
                  </Grid>
                </CardBody>
              </Card>
            </CardBody>
          </Card>
        </Grid>

        <Grid container item lg={12} xs={12}>
          <Card>
            <CardBody>
              <Grid item xs={12}>
                <h3>
                  <TranslationWrapper
                    tDefault={"Links to screens"}
                    tKey={"vestigingen.keukenscherm.keukenschermLinkTitel"}
                  />
                </h3>
              </Grid>

              <Card>
                <CardBody>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={12}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Keukenscherm link"}
                          tKey={"vestigingen.keukenscherm.keukenschermLink"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={12}>
                      <a href={getView} rel={"noreferrer"} target={"_blank"}>
                        {getView}
                      </a>
                      <Tooltip title={<TranslationWrapper tDefault={"Kopieer"} tKey={"global.tooltip.kopieer"} />}>
                        <Button justIcon onClick={() => copyToClipBoard(getView)} size={"sm"}>
                          <FileCopy />
                        </Button>
                      </Tooltip>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={12}>
                      <FormLabel>
                        <TranslationWrapper tDefault={"Order screen "} tKey={"vestigingen.keukenscherm.osView"} />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={12}>
                      <a href={getViewOs} rel={"noreferrer"} target={"_blank"}>
                        {getViewOs}
                      </a>
                      <Tooltip title={<TranslationWrapper tDefault={"Kopieer"} tKey={"global.tooltip.kopieer"} />}>
                        <Button justIcon onClick={() => copyToClipBoard(getViewOs)} size={"sm"}>
                          <FileCopy />
                        </Button>
                      </Tooltip>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={12}>
                      <FormLabel>
                        <TranslationWrapper tDefault={"Tijd Scherm"} tKey={"vestigingen.keukenscherm.timeschermLink"} />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={12}>
                      <a href={getTimeView} rel={"noreferrer"} target={"_blank"}>
                        {getTimeView}
                      </a>
                      <Tooltip title={<TranslationWrapper tDefault={"Kopieer"} tKey={"global.tooltip.kopieer"} />}>
                        <Button justIcon onClick={() => copyToClipBoard(getTimeView)} size={"sm"}>
                          <FileCopy />
                        </Button>
                      </Tooltip>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={4} style={{ paddingTop: "10px" }} xs={12}>
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Tijd Scherm (Oude Browser)"}
                          tKey={"vestigingen.keukenscherm.timeschermOudeBrouwserLink"}
                        />
                      </FormLabel>
                    </Grid>
                    <Grid item sm={8} xs={12}>
                      <a href={getTimeViewOld} rel={"noreferrer"} target={"_blank"}>
                        {getTimeViewOld}
                      </a>
                      <Tooltip title={<TranslationWrapper tDefault={"Kopieer"} tKey={"global.tooltip.kopieer"} />}>
                        <Button justIcon onClick={() => copyToClipBoard(getTimeViewOld)} size={"sm"}>
                          <FileCopy />
                        </Button>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <Grid item sm={4} style={{ paddingTop: "10px" }} xs={12}>
                    <FormLabel>
                      <TranslationWrapper
                        tDefault={"Order screen background"}
                        tKey={"vestigingen.form.zuil.label.extra_settings__osBackground"}
                      />
                    </FormLabel>
                  </Grid>
                  <Grid item sm={8} xs={12}>
                    <FormFile name={"extra_settings__osBackground"} type={"image"} />
                  </Grid>
                </CardBody>
              </Card>
              <FormAsyncTC
                async={{
                  url: "core/vestigingen/search?fields=id as value, systeemNaam as label&per_page=1000&sort_field=systeemNaam",
                  searchField: "systeemNaam",
                }}
                key={"keukenscherm__vestigingen" + vestigingId}
                multiple={true}
                name={"keukenscherm__vestigingen"}
                tDefault={"Selecteer een verkoopgebied"}
                tKey={"vestigingen.form.vestigingen.taglist.menuFood.headerText"}
              />
            </CardBody>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}

export default Keukenscherm;
